import { Select } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import type { ReportCompareValue } from "../../types/canvas.types.ts"

const NONE = "none"
type CompareSelectValue = "none" | "previous_period" | "same_period_last_year"

const OPTION_LABEL_KEYS: Record<CompareSelectValue, string> = {
  none: "reports.compare.none",
  previous_period: "reports.compare.previousPeriod",
  same_period_last_year: "reports.compare.samePeriodLastYear"
}

interface ReportCompareControlProps {
  compare: ReportCompareValue | undefined
  onChange: (compare: ReportCompareValue) => void
  disabled?: boolean
}

export const ReportCompareControl = ({
  compare,
  onChange,
  disabled = false
}: ReportCompareControlProps) => {
  const { t } = useTranslation()

  const value: CompareSelectValue = compare ?? NONE

  return (
    <Select<CompareSelectValue>
      aria-label={t("reports.compare.label")}
      value={value}
      onChange={(next) => onChange(next === NONE ? null : next)}
      disabled={disabled}
      style={{ minWidth: 180 }}
      options={(
        Object.keys(OPTION_LABEL_KEYS) as CompareSelectValue[]
      ).map((option) => ({
        label: t(OPTION_LABEL_KEYS[option]),
        value: option
      }))}
    />
  )
}
